import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { PAYOUTS_FACETS_QUERY_KEY, PAYOUTS_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useCancelVendorPayment() {
  const {
    mutate: cancelVendorPayment,
    isLoading: isCancelling,
    isSuccess: isCancelled,
  } = useMutation({
    mutationFn: async (vendorPaymentId: string) => {
      return await CampaignService.cancelVendorPaymentsExport(
        vendorPaymentId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (client) => {
      ToastService.success("Payout cancelled");
      setTimeout(() => {
        client.invalidateQueries({ queryKey: [...PAYOUTS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUTS_FACETS_QUERY_KEY()] });
      }, 1000);
    },
    options: { skipInvalidation: true },
  });

  return {
    cancelVendorPayment,
    isCancelling,
    isCancelled,
  };
}
